export default __webpack_public_path__ + "static/media/rakeshLink.82c1b986.png";